import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  withStyles,
  IconButton,
} from '@material-ui/core';
import {
  CloseIcon,
} from 'shared-library/dist/components/material-icon';
import { safeGate } from '@src/services/auth-service';

const useStyles = makeStyles((theme) => {
  const surfaceConfig = theme.palette.surface[theme.palette.type];
  const containedConfig = surfaceConfig.button.contained;
  const outlinedConfig = surfaceConfig.button.outlined;
  const buttonConfig = theme.typography.button;

  return {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      alignItems: 'center',
      justifyContent: 'left',
    },
    btnContained: {
      marginLeft: 0,
      paddingLeft: buttonConfig.paddingLeft,
      paddingRight: buttonConfig.paddingRight,
      borderRadius: buttonConfig.borderRadius,
      height: buttonConfig.height,
      backgroundColor: containedConfig.bgColor,
      '&:hover': {
        backgroundColor: containedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: containedConfig.border,
        borderColor: containedConfig.borderColor,
        backgroundColor: containedConfig.bgColor,
      },
    },
    btnOutlined: {
      border: outlinedConfig.border,
      color: outlinedConfig.color,
      marginRight: theme.spacing(1),
      backgroundColor: outlinedConfig.bgColor,
      '&:hover': {
        border: outlinedConfig.hoveredBorder,
        backgroundColor: outlinedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: outlinedConfig.selectedBorder,
        backgroundColor: outlinedConfig.selectedBgColor,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    iframe: {
      width: 500,
      height: 400,
      border: 0,
    },
  };
});

const LoginDialog = ({
  open,
  title,
  onClose,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        disableBackdropClick
      >
        <DialogTitle>
          {title}
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <span />
        </DialogTitle>
        <DialogContent>
          <iframe
            seamless
            className={classes.iframe}
            title="user-login"
            src={`${safeGate}?redirect_url=/`}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

LoginDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

LoginDialog.defaultProps = {
  title: 'Login',
  onClose: undefined,
};

export default LoginDialog;
